import { FormEvent } from "react";
import { store } from "../store";
import { getWidgetConfig } from "../reducers/methods";
import { StoreState } from "../reducers/";
import { sendElementClicked, sendKeyDown } from "../actions";
import { Action } from "redux";

let listenerSetup: boolean = false;

export function isEditMode(): boolean {
  const state = store.getState() as StoreState;
  const config = getWidgetConfig(state);

  return config && config.__editMode__;
}

export function sendClickToMerchant(
  event: FormEvent<HTMLElement>,
  configName: string
): boolean {
  if (isEditMode()) {
    event.stopPropagation();
    event.preventDefault();

    if (!listenerSetup) {
      setupListener();
      listenerSetup = true;
    }

    store.dispatch(sendElementClicked(event, configName) as Action);

    return true;
  } else if (listenerSetup) {
    removeListener();
    listenerSetup = false;
  }

  return false;
}

export const onClickSendToMerchant =
  (configName: string) => (event: FormEvent<HTMLElement>) =>
    sendClickToMerchant(event, configName);

function onKeyDown(event: KeyboardEvent) {
  event.preventDefault();
  store.dispatch(
    sendKeyDown({
      code: event.code,
      ctrlKey: event.ctrlKey,
      metaKey: event.metaKey,
      shiftKey: event.shiftKey,
    })
  );
}

function setupListener() {
  window.addEventListener("keydown", onKeyDown);
}

function removeListener() {
  window.removeEventListener("keydown", onKeyDown);
}
